import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useDPSRoute = () => {
  const location = useLocation();

  useEffect(() => {
    const isDPSRoute = location.pathname.startsWith('/dps/report/');

    if (isDPSRoute) {
      document.documentElement.style.backgroundColor = 'rgb(15, 23, 42)';
      document.body.style.backgroundColor = 'rgb(15, 23, 42)';
      document.body.style.overscrollBehaviorY = 'none';
    } else {
      document.documentElement.style.backgroundColor = '';
      document.body.style.backgroundColor = '';
      document.body.style.overscrollBehaviorY = '';
    }

    return () => {
      document.documentElement.style.backgroundColor = '';
      document.body.style.backgroundColor = '';
      document.body.style.overscrollBehaviorY = '';
    };
  }, [location.pathname]);
};
